import React, { useState } from "react";
import {
  Card,
  DataTable,
  Text,
  BlockStack,
  Button,
  Modal,
  Badge,
} from "@shopify/polaris";

const ExpertWorkShopTable = ({ products, indexing = 1, perPage }) => {
  const [activeProduct, setActiveProduct] = useState(null);
  const [activeInvoice, setActiveInvoice] = useState(null);
  const [activeSlogan, setActiveSlogan] = useState(null);
  const getDecimalValue = (value) => {
    if (value && typeof value === "object" && value.$numberDecimal) {
      return value.$numberDecimal;
    }

    return value || "0";
  };
  const rows =
    products?.map((item, index) => [
      index + 1 + (indexing - 1) * perPage,

      <Badge tone="new">{item._id || "—"}</Badge>,

      item.name || "—",

      item.email || "—",

      item.phone || "—",

      item.pincode || "—",

      item.store || "—",

      item.sessionType || "—",

      item.timing || "—",

      item.date || "—",

      item.createdAt ? new Date(item.createdAt).toLocaleDateString() : "—",
    ]) || [];
  const headings = [
    "SN",
    "Reference No",
    "Name",
    "Email",
    "Phone",
    "Pincode",
    "Store",
    "Session Type",
    "Timing",
    "Session Date",
    "Created At",
  ];
  return (
    <>
      <Card>
        <DataTable
          columnContentTypes={headings.map((heading) =>
            heading === "SN" ? "numeric" : "text",
          )}
          headings={headings}
          rows={rows}
        />
      </Card>

      <Modal
        open={!!activeInvoice}
        onClose={() => setActiveInvoice(null)}
        title={`Invoiced Products - ${activeInvoice?.name || ""}`}
        primaryAction={{
          content: "Close",
          onAction: () => setActiveInvoice(null),
        }}
      >
        <Modal.Section>
          {activeInvoice?.invoicedProducts?.length > 0 ? (
            activeInvoice.invoicedProducts.map((prod, i) => (
              <BlockStack key={i} gap="200">
                <Text variant="bodyMd">
                  <b>SKU:</b> {prod.sku}
                </Text>
                <Text variant="bodySm">
                  <b>Quantity:</b> {prod.quantity}
                </Text>
                <Text variant="bodySm">
                  <b>Total Price:</b> ₹{getDecimalValue(prod.total_price)}
                </Text>
                {i !== activeInvoice?.invoicedProducts?.length - 1 ? (
                  <hr />
                ) : null}
              </BlockStack>
            ))
          ) : (
            <Text>No invoiced products found</Text>
          )}
        </Modal.Section>
      </Modal>
      <Modal
        open={!!activeProduct}
        onClose={() => setActiveProduct(null)}
        title="Eligible Products"
        primaryAction={{
          content: "Close",
          onAction: () => setActiveProduct(null),
        }}
      >
        <Modal.Section>
          {activeProduct?.eligibleProducts?.map((prod, i) => (
            <BlockStack key={i} gap="200">
              <Text variant="bodyMd">
                <b>Title:</b> {prod.title}
              </Text>
              <Text variant="bodySm">
                <b>SKU:</b> {prod.sku}
              </Text>
              <Text variant="bodySm">
                <b>Category:</b> {prod.category}
              </Text>
              <Text variant="bodySm">
                <b>Quantity:</b>
                {getDecimalValue(prod.quantity)}
              </Text>
              <Text variant="bodySm">
                <b>Price:</b> ₹{getDecimalValue(prod.total_price)}
              </Text>
              {i !== activeProduct.eligibleProducts.length - 1 ? <hr /> : null}
            </BlockStack>
          ))}
        </Modal.Section>
      </Modal>
      <Modal
        open={!!activeSlogan}
        onClose={() => setActiveSlogan(null)}
        title="Slogan"
        primaryAction={{
          content: "Close",
          onAction: () => setActiveSlogan(null),
        }}
      >
        <Modal.Section>{activeSlogan?.slogan}</Modal.Section>
      </Modal>
    </>
  );
};

export default ExpertWorkShopTable;
